import PhotoSwipe from 'photoswipe';

class Gallery {

	constructor(node) {
		this.node = node;
		this.pswp = document.querySelector('.pswp');
		this.ui = window.PhotoSwipeUI_Default;
		this.options = {
			showHideOpacity: true,
			bgOpacity: .9,
			history: false,
			index: 0
		};
		this.figures = Array.from(this.node.querySelectorAll('.gallery-item'));

		this.data = this.figures.map((fig, index) => {
			const data = {};
			const img = fig.querySelector('img');
			const figcaption = fig.querySelector('figcaption');

			fig.dataset.photoswipeIndex = index;
			
			data.src = img.src;
			data.h = parseInt(fig.dataset.height, 10);
			data.w = parseInt(fig.dataset.width, 10);
			
			if (figcaption) {
				data.title = figcaption.innerHTML;
			}

			return data;
		});

		// bail if no photoswipe markup
		if (!this.pswp) {
			return;
		}

		this.node.addEventListener('click', (e) => {
			let node = e.target;
			while (!node.matches('.gallery-item a')) {
				if (node === this.node) {
					return;
				}
				node = node.parentNode;
			}
			e.preventDefault();

			this.options.index = parseInt(node.parentNode.dataset.photoswipeIndex);

			this.photoswipe = new PhotoSwipe(this.pswp, this.ui, this.data, this.options);
			this.photoswipe.init();
		});
	}
}

const init = function () {
	return Array.from(document.querySelectorAll('.gallery')).map((node) => {
		return new Gallery(node);
	});
}

export default {
	gallery: Gallery,
	init: init
}